export default {"src":"/_next/static/media/carDetailImgCountIcon.0743f86a.svg","height":16,"width":14};